<template>
	<div class="c-user-contanier">
		<div class="header">
			<BackTitle title="队员详情" />
		</div>

        <div class="user-image">
            <img :src="actualUserImage" class="image-display" />
            <img src="./images/role-shadow.png" class="user-shadow">
        </div>

		<div class="main">
			<!-- 侧边栏 -->
			<LMenu class="user-menu" v-model="menuActive" />
			<div class="user-content">
                        <!-- 头像姓名 -->
                        <div class="user-header">
                            <div class="header-avatar">
                                <img :src="userinfo.headImg || defaultHeadImg" class="avatar-img">
                            </div>
                            <div class="user-names">
                                <p class="user-name">{{ userinfo.cnName }}</p>
                                <p class="user-id">ID: {{ userinfo.studyCard }}</p>
                            </div>
                        </div>
                        <BaseInfo v-show="menuActive === 0" :lessonNum="lessonNum" :giftNum="giftNum"></BaseInfo>
                        <Gifts v-show="menuActive === 1" :giftRecord="giftRecord" />
            </div>
		</div>

        <div class="footer">
            <span class="header-tab" @click="stuffDialogVisible = true">
                <img src="./images/icon-sendgift.png" alt="" class="tab-icon">
                赠送礼物
            </span>
        </div>

        <MallDialog :visible.sync="stuffDialogVisible" :hideFooter="giftList.length !== 0" width="7.6rem" title="我的物品" confirmBtnText="去购买" :confirm="handleGoMall">
            <StuffList :list="giftList">
                <StuffItem v-for="item in giftList" :key="item.id" :detail="item" @used="handleSentGift" />
            </StuffList>
        </MallDialog>
	</div>
</template>

<script>
import BaseInfo from "./components/BaseInfo.vue"
import Gifts from "./components/Gifts.vue"
import LMenu from "./components/l-menu/l-menu"
import BackTitle from "@/components/back-title/BackTitle.vue"
import { apiGetUserAssets, apiGetMallUserInfo, apiUseAsset, apiGetReceivedGifts } from "@/models/mall"
import { GoodsType, PropType, AssetStatus } from "@/constants/mall"
import defaultHeadImg from "./images/headImg.png"
import RoleBaseGirl from './images/role-girl-base.png'
import RoleBaseBoy from './images/role-boy-base.png'
import MallDialog from "@/components/mall-dialog/index.vue"
import StuffList from "./components/StuffList.vue"
import StuffItem from "./components/StuffItem.vue"

export default {
	name: "UserDetail",
	components: {
		BaseInfo,
        Gifts,
		LMenu,
		BackTitle,
        MallDialog,
        StuffList,
        StuffItem,
	},
	data() {
		return {
            defaultHeadImg,
            menuActive: 0,
            userId: this.$route.query.userId,
            userinfo: {}, // 用户信息
            lessonNum: 0, // 关卡数量
            giftNum: 0, // 礼物数量
            classInfo: {}, // 班级信息
            giftRecord: [], // 礼物记录
            usedPropList: [], // 使用中的道具
            allAssets: [], // 所有资产
            stuffDialogVisible: false,
		}
	},
    computed: {
        // 在用装扮
        usedDress() {
          return this.usedPropList.find((item) => item.type === GoodsType.DRESS_UP)
        },
        // 用户形象
        actualUserImage() {
            const defaultImage = this.userinfo.sex === 1 ? RoleBaseBoy : RoleBaseGirl
            const usedDress = this.usedDress ? this.usedDress.img : null
            return usedDress || defaultImage
        },
		// 道具列表
		propList() {
			return this.allAssets.filter((item) => item.type === GoodsType.PROP) || []
		},
        // 礼物列表
        giftList() {
            return this.propList.filter((item) => item.typeInfo.type === PropType.GIFT) || []
        },
    },
	methods: {
        async getUserAssets() {
            try {
                const res = await apiGetUserAssets()
                this.allAssets = res.data || []
            } catch (error) {
                console.error(error)
            }
        },
        //获取用户信息
        async getUserInfo() {
            const {data} = await apiGetMallUserInfo({
                userId: this.userId,
            })
            this.userinfo = data.user || {}
            this.classInfo = data.classInfo || {}
            this.usedPropList = data.useList || []
            this.lessonNum = data.lessonNum || 0
            this.giftNum = data.giftNum || 0
        },
        // 获取礼物记录
        async getGiftRecord() {
            const res = await apiGetReceivedGifts(this.userId)
            this.giftRecord = res.data
        },
        async handleSentGift(item) {
            try {
                this.$lLoading.show()
                await apiUseAsset({
                    id: item.id,
                    status: AssetStatus.USED,
                    targetId: this.userId,
                })
                this.$lPrompt({
                    message: '赠送成功',
                    successTxt: '确定',
                })
            } finally {
                this.$lLoading.hide()
            }
            this.getUserInfo()
            this.getUserAssets()
            this.getGiftRecord()
            this.stuffDialogVisible = false
        },
        handleGoMall() {
            this.$router.push({
                path: "/mall",
            })
        },
	},
	mounted() {
		this.getUserInfo()
        this.getUserAssets()
        this.getGiftRecord()
	},
}
</script>

<style scoped>
.c-user-contanier {
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	height: 100%;
	padding-top: 24px;
	background: url("../images/flower-bg.png") center/cover no-repeat;
	overflow: hidden;
}
.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.main {
	display: flex;
	margin-top: 80px;
	overflow: hidden;
}
.user-menu {
	margin-left: 76px;
}
.user-content {
	margin-left: 100px;
	margin-right: 72px;
	overflow: hidden;
}
.user-header {
  display: flex;
  align-items: center;
  margin-bottom: 72px;
}
.header-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  margin-right: 16px;
  background: #fff3d3;
  box-shadow: 0px 1px 3px 0px rgba(103,27,6,0.61), 0px -1px 1px 0px rgba(217,138,67,0.80) inset; 
  border-radius: 50%;
}
.avatar-img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.user-names {
  text-align: left;
}
.user-name {
  margin: 0;
  font-size: 24px;
  font-weight: bold;
  color: #fff;
}
.user-id {
  margin: 0;
  margin-top: 12px;
  font-size: 20px;
  color: #fff;
}

.user-image {
  position: absolute;
  top: 132px;
  right: 100px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
.image-display {
  width: 280px;
  margin-bottom: -48px;
}
.user-shadow {
  width: 400px;
  margin-top: -20px;
  margin-bottom: -40px;
}


.footer {
    display: flex;
    justify-content: center;
    margin-top: 40px;
}
.header-tab {
    display: flex;
    align-items: center;
    padding: 10px 48px;
    background: #ffe952;
    border-radius: 28px;
    box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ffbe31 inset; 
    font-size: 24px;
    font-weight: bold;
    color: #DD7146;
    cursor: pointer;
}
.tab-icon {
    width: 32px;
    height: 32px;
    margin-right: 16px;
}
</style>
